var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/video-component.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<!-- Video Component -->\n";
output += "\n\n    ";
output += "\n";
if(runtime.contextOrFrameLookup(context, frame, "isLazy")) {
output += "\n    ";
var t_1;
t_1 = "data-src";
frame.set("srcAttr", t_1, true);
if(frame.topLevel) {
context.setVariable("srcAttr", t_1);
}
if(frame.topLevel) {
context.addExport("srcAttr", t_1);
}
output += "\n    ";
var t_2;
t_2 = "b-lazy ";
frame.set("lazyVideoClass", t_2, true);
if(frame.topLevel) {
context.setVariable("lazyVideoClass", t_2);
}
if(frame.topLevel) {
context.addExport("lazyVideoClass", t_2);
}
output += "\n    ";
var t_3;
t_3 = "lazyload";
frame.set("lazyPosterClass", t_3, true);
if(frame.topLevel) {
context.setVariable("lazyPosterClass", t_3);
}
if(frame.topLevel) {
context.addExport("lazyPosterClass", t_3);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_4;
t_4 = "src";
frame.set("srcAttr", t_4, true);
if(frame.topLevel) {
context.setVariable("srcAttr", t_4);
}
if(frame.topLevel) {
context.addExport("srcAttr", t_4);
}
output += "\n    ";
var t_5;
t_5 = "";
frame.set("lazyVideoClass", t_5, true);
if(frame.topLevel) {
context.setVariable("lazyVideoClass", t_5);
}
if(frame.topLevel) {
context.addExport("lazyVideoClass", t_5);
}
output += "\n    ";
var t_6;
t_6 = "";
frame.set("lazyPosterClass", t_6, true);
if(frame.topLevel) {
context.setVariable("lazyPosterClass", t_6);
}
if(frame.topLevel) {
context.addExport("lazyPosterClass", t_6);
}
output += "\n";
;
}
output += "\n\n";
var t_7;
t_7 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"deviceCharacteristics")),"is_smallish");
frame.set("isSmallOrExtraSmallScreen", t_7, true);
if(frame.topLevel) {
context.setVariable("isSmallOrExtraSmallScreen", t_7);
}
if(frame.topLevel) {
context.addExport("isSmallOrExtraSmallScreen", t_7);
}
if((lineno = 21, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.videoPosterImage.fields"])) || (lineno = 21, colno = 75, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.externalPosterImage"]))) {
var t_8;
t_8 = (lineno = 23, colno = 36, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.externalPosterImage"])) || (lineno = 23, colno = 90, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.videoPosterImage.fields.file.url"]));
frame.set("posterImage", t_8, true);
if(frame.topLevel) {
context.setVariable("posterImage", t_8);
}
if(frame.topLevel) {
context.addExport("posterImage", t_8);
}
;
}
if((lineno = 27, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.iframeEmbedCode"]))) {
if(runtime.contextOrFrameLookup(context, frame, "posterImage")) {
output += "<div class=\"c-external-video-poster js-external-video-poster\">\n\n        <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "posterImage"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue((lineno = 33, colno = 52, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.title"])), env.opts.autoescape);
output += "\" class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lazyPosterClass"), env.opts.autoescape);
output += "\"  />\n\n    </div>";
;
}
output += "<div class=\"c-external-video js-video js-external-video";
if(!runtime.contextOrFrameLookup(context, frame, "posterImage")) {
output += " is-visible";
;
}
output += "\" data-qa-iframe-video>\n\n        ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 41, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.iframeEmbedCode"]))), env.opts.autoescape);
output += "\n\n    </div>";
;
}
else {
if((lineno = 45, colno = 19, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.video.fields.file.url"])) || (lineno = 45, colno = 75, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.externalVideoUrl"]))) {
var t_9;
t_9 = (lineno = 47, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.externalVideoUrl"])) || (lineno = 47, colno = 82, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.video.fields.file.url"]));
frame.set("source", t_9, true);
if(frame.topLevel) {
context.setVariable("source", t_9);
}
if(frame.topLevel) {
context.addExport("source", t_9);
}
output += "<video\n        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "srcAttr"), env.opts.autoescape);
output += "=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "source"), env.opts.autoescape);
output += "\"";
if(runtime.contextOrFrameLookup(context, frame, "posterImage")) {
output += " poster=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "posterImage"), env.opts.autoescape);
output += "\" ";
;
}
output += "class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lazyVideoClass"), env.opts.autoescape);
output += "js-video\"\n        controls\n        data-tracking-slug=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"trackingSlug"), env.opts.autoescape);
output += "\"\n        data-analytics-title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"title"), env.opts.autoescape);
output += "\"\n        data-qa-video";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"loop")) {
output += runtime.suppressValue(" loop ", env.opts.autoescape);
;
}
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"autoplay") && !(runtime.contextOrFrameLookup(context, frame, "isMobileSlider") && runtime.contextOrFrameLookup(context, frame, "isSmallOrExtraSmallScreen"))) {
output += runtime.suppressValue(" autoplay muted ", env.opts.autoescape);
;
}
output += ">";
if(runtime.contextOrFrameLookup(context, frame, "posterImage")) {
output += "<img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "posterImage"), env.opts.autoescape);
output += "\" class=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "lazyPosterClass"), env.opts.autoescape);
output += "\" />";
;
}
output += "</video>";
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/video-component.j2"] , dependencies)